import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import InlineList from 'components/InlineList';
import Disclosure from 'components/Disclosure';
import TagPill from 'components/Pill/PillVariants/TagPill';
import Text from 'components/Text';
import UserGeneratedText from 'components/UserGeneratedText';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function InfoSection(_ref) {
  var _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description,
    _ref$tags = _ref.tags,
    tags = _ref$tags === void 0 ? [] : _ref$tags;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var hasTags = tags.length !== 0;
  var hasInfoSection = description || hasTags;
  if (!hasInfoSection) return null;
  return /*#__PURE__*/_jsxs(Disclosure.Provider, {
    children: [/*#__PURE__*/_jsx(Disclosure.Toggle, {
      mt: "m",
      children: t('asset_viewer_info')
    }), /*#__PURE__*/_jsxs(Disclosure.Hidden, {
      fontSize: "s",
      children: [description && /*#__PURE__*/_jsx(UserGeneratedText, {
        text: description
      }), hasTags && /*#__PURE__*/_jsxs(Box, {
        mt: "s",
        children: [/*#__PURE__*/_jsxs(Text, {
          as: "strong",
          display: "block",
          mb: "xxs",
          children: [t('content_type_tag_plural'), ":"]
        }), /*#__PURE__*/_jsx(InlineList, {
          spacing: "xxs",
          children: tags.map(function (tag, index) {
            return /*#__PURE__*/_jsx(TagPill, {
              link: tag.location,
              children: tag.title
            }, tag.id || index);
          })
        })]
      })]
    })]
  });
}
export default InfoSection;